import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { cn } from "@omni/utils/styles";

import { ProductTileLayout } from "@/components/Product/ProductTile/productTile.config";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import { useMapped } from "@/context/mapped.context";
import { useIsBreakpoint } from "@/utils/breakpoints/breakpoints.provider";

import { useProductsContext } from "../context/products.context";

const Product = () => {
    const { products } = useProductsContext();

    const { index } = useMapped();
    const product = products.at(index);
    const { matches: isSm, ready } = useIsBreakpoint("sm");

    if (!product || !ready) return null;

    const productTileComponents = (
        isSm ? ProductTileLayout.PLP : ProductTileLayout.PLP_HORIZONTAL
    )(true, false, false);

    return (
        <ProductTile
            product={ProductMapper.fromFullToProductTile(product)}
            sku={product.sku}
            allowInstantAddToCart={false}
            className={cn("tw:text-left")}
            productTileConfig={{
                amountOfFeatures: 3,
                components: productTileComponents,
                hoverEffect: true,
                border: true
            }}
        />
    );
};

export { Product };
